import { useCallback, useState } from 'react';

/**
 * Use this hook to catch errors in asynchronous code like events and promises.
 *
 * @returns [setError, clearError (is not supported)]
 *
 * @example
 * ```tsx
 * function Example() {
 *  const [showError] = useErrorBoundary();
 *  useEffect(() => {
 *    getSomeData().then(data => {
 *      // do something with data
 *    },
 *    error => {
 *      showError(error);
 *    });
 *  });
 *
 *  return // render
 * }
 * ```
 *
 * @see https://github.com/bvaughn/react-error-boundary#useerrorboundary-hook
 */
export function useErrorBoundary() {
  const [error, setError] = useState<Error>();
  if (error) throw error;

  /**
   * @deprecated Is not supported
   */
  const clearError = useCallback(() => setError(undefined), []);

  return [setError, clearError] as const;
}
